module.exports = __webpack_public_path__ + "static/img/8-2.46ea4f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/8-2.jpg
// module id = D5PR
// module chunks = 0